var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cloud-login-w",on:{"click":_vm.init}},[_vm._v("正在跳转，请稍后...")])}
var staticRenderFns = []

export { render, staticRenderFns }